/*
 Auto-generated by generate-java-to-ts-maven-plugin. Do not edit.
 Source: de.mhus.vance.api.roles.ProjectRole
*/
export var ProjectRole;
(function (ProjectRole) {
    ProjectRole["READER"] = "READER";
    ProjectRole["MEMBER"] = "MEMBER";
    ProjectRole["ADMIN"] = "ADMIN";
})(ProjectRole || (ProjectRole = {}));
//# sourceMappingURL=ProjectRole.js.map